import styled from 'styled-components';
import { Collapse, Card } from 'antd';
const isMobile = window.innerWidth < 768;

export const PageName = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: white;
  border-radius: 50px;
  padding: 5px 5px;
  margin: 32px 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
`;

export const SearchIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: rgba(231, 250, 255, 1);
  
  svg {
    font-size: 24px;
    color: rgba(0, 141, 210, 1); 
  }
`;

export const SearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  padding: 10px;
  font-size: 18px;
  line-height: 24px;
  background-color: transparent;
`;

export const SearchButton = styled.button`
  background-color: #00bfff;
  color: white;
  border: none;
  padding: ${isMobile ? '0' : '10px 30px'};
  border-radius: ${isMobile ? '50%' : '40px'};
  font-size: ${isMobile ? '0' : '18px'};
  font-weight: 600;
  cursor: pointer;
  width: ${isMobile ? '50px' : 'auto'};
  height: ${isMobile ? '50px' : 'auto'};
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: #00a3e0;
  }
`;

export const StyledCard = styled(Card)`
  padding: 0 !important;
  
  .ant-card-body {
    padding: 0 !important; 
  }

  .ant-table-wrapper .ant-table-thead >tr>th {
    background: rgba(244, 245, 247, 1) !important;
  }

   .ant-table-container table>thead>tr:first-child >* {
   border-radius: 0 !important;
   height: 72px;
   border: 1px solid rgba(229, 233, 242, 1);
   }

   .ant-table-cell {
   height: 72px;
   }

   .ant-table-wrapper .ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
   display: none;
}
`;